import styled from "@emotion/styled";
import PrimaryButton from "shared/components/PrimaryButton";

export const StyledButton = styled(PrimaryButton)`
  position: absolute;
  right: 0;
  top: 0;
  width: 150px;
`;